import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ecde20d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pause-panel-inner" }
const _hoisted_2 = { class: "brand fade-in" }
const _hoisted_3 = { class: "brand-primary" }
const _hoisted_4 = { class: "logo-brand" }
const _hoisted_5 = { class: "secondary-menu fade-in" }
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "simulation-status" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "status" }
const _hoisted_10 = { class: "nav" }
const _hoisted_11 = { class: "primary-menu font-bold" }
const _hoisted_12 = { class: "primary-menu-container" }
const _hoisted_13 = { class: "sub-menu" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))

import { computed, ComputedRef, nextTick, onMounted, Ref, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Howler } from 'howler';
import gsap from 'gsap'
import Tracking from "@/core/Tracking";
import { useAppState, useGameState, useNetworkState } from '@/services/composition'
import Viewport from '@/store/modules/Viewport'
import AudioManager from "@/core/audio/AudioManager"

import UIPanelPauseLink from './UIPanelPauseLink.vue'
import UIBrands from '@/components/UIBrands/UIBrands.vue'
import { Role } from '@/services/states/AppStateMachine'

type Link = {
  label: string
  action: string
  active: boolean
}
// const links: ComputedRef<Array<Link>> = computed(() => {
//   const a = [];

//   if (state.value.matches('end.failed')) {
//     a.push({
//       label: t('pause.primary_nav.restart'),
//       action: 'GAME_RESTART',
//       active: true
//     })
//   }
//   if (state.value.context.isPaused) {
//     a.push({
//       label: t('pause.primary_nav.resume'),
//       action: 'GAME_TOGGLE_PAUSE',
//       active: true
//     })
//   }

//   a.push({
//     label: t('pause.primary_nav.home'),
//     action: 'GAME_BACK_HOME',
//     active: false
//   })

//   return a
// })


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { send, state: appState } = useAppState()
const state = useGameState()
const networkState = useNetworkState()
const { t } = useI18n()

const simulationStatus = computed(() => {
  if (!state.value.matches('intro') && appState.value.context.role !== Role.Desktop && networkState.value.context.actorCount !== 2) {
    return {
      label: t('disconnected.simulation_status.label'),
      title: t('disconnected.simulation_status.title')
    }
  }
  if (state.value.matches('end.failed')) {
    return {
      label: null,
      title: t('fail.simulation_status.title')
    }
  }
  return {
    label: null,
    title: t('pause.simulation_status.title')
  }
})

const theme = computed(() => {
  return appState.value.context.role === Role.Companion ? 'dark' : 'light'
})

const links: Ref<Array<Link>> = ref([])

const onMouseEnter = (link: Link) => {
  links.value.forEach((l) => { if (l !== link) l.active = false } )
  link.active = true
}
const onMouseLeave = () => {
  // links.value.forEach((l, index) => { l.active = index === 0 } )
}

const sound = ref(null)
const toggleAudio = () => {
  const isMuted = Howler.volume() === 0

  if (isMuted) {
    sound.value?.play()
  } else {
    sound.value?.pause()
  }

  AudioManager.setMute(isMuted ? false : true)
}

onMounted(() => {
  links.value = []
  if (state.value.matches('end.failed')) {
    links.value.push({
      label: t('pause.primary_nav.restart'),
      action: 'GAME_RESTART',
      active: true
    })
  }
  if (state.value.context.isPaused) {
    links.value.push({
      label: t('pause.primary_nav.resume'),
      action: 'GAME_TOGGLE_PAUSE',
      active: true
    })
  }
  links.value.push({
    label: t('pause.primary_nav.home'),
    action: 'GAME_BACK_HOME',
    active: false
  })
})


const onEnter = async (el: HTMLElement, onComplete: gsap.Callback) => {
  const $ = gsap.utils.selector(el)

  await nextTick();

  const tl = gsap.timeline({ onComplete })
    .fromTo([el],  {
        y: 100
      }, {
        y: 0,
        duration: 1,
        ease: 'power1'  
      }, 'start')


    if (Viewport.isDesktop) {
      tl
        .fromTo([$('.status')],  {
            yPercent: 100
          }, {
            yPercent: 0,
            duration: 1,
            ease: 'quart.out'  
          }, 'start+=0.2')
        .fromTo([$('.primary-menu-container .text > span')], {
          yPercent: 100
        }, {
          yPercent: 0,
          duration: 0.5,
          ease: 'quart.out',
          stagger: 0.1,
        }, 'start+=0.6')

        .fromTo([$('.fade-in')],  {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 0.6,
            ease: "power2.inOut"
          }, 'start+=0.6')
    } else {
      tl
        .fromTo([$('.fade-in, .nav, .simulation-status')],  {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 0.6,
            ease: "power2.inOut"
          }, 'start+=0.3')
    }
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_btn_icon = _resolveComponent("ui-btn-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "long-fade",
    appear: true,
    onEnter: onEnter
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["panel-pause", _unref(theme)])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_ui_icon, { name: "logo-brand" })
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ui_btn_icon, {
                ref_key: "sound",
                ref: sound,
                class: "btn-sound",
                name: "sound",
                variant: "secondary",
                color: _unref(theme) === 'light' ? 'dark-red' : 'light',
                isLottie: true,
                onClick: toggleAudio
              }, null, 8, ["color"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(simulationStatus).label), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(simulationStatus).title), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: link.action
                      }, [
                        _createVNode(UIPanelPauseLink, {
                          active: link.active,
                          text: link.label,
                          onClick: ($event: any) => (_unref(send)(link.action)),
                          onMouseenter: ($event: any) => (onMouseEnter(link)),
                          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (onMouseLeave()))
                        }, null, 8, ["active", "text", "onClick", "onMouseenter"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("a", {
                  class: "sub-menu_link text-body",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {
                  _unref(send)({ type: 'SET_PAGE_PANEL', id: 'cookies' });
                  _unref(Tracking).cookies();
                }, ["prevent"])),
                  href: "#cookies_policy"
                }, _toDisplayString(_unref(t)('pause.secondary_nav.cookies_settings')), 1),
                _hoisted_14,
                _createElementVNode("a", {
                  class: "sub-menu_link text-body",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => {
                  _unref(send)({ type: 'SET_PAGE_PANEL', id: 'privacy' });
                  _unref(Tracking).privacy();
                }, ["prevent"])),
                  href: "#privacy_policy"
                }, "Privacy Policy")
              ])
            ])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})